import React from 'react';
import WhatsAppButton from '../components/WhatsAppButton/WhatsAppButton';
import {
  presentation,
  mission,
  vision,
  values,
  whyWote,
  company,
} from '../data/siteContent';
import '../styles/waves.css';
import './About.css';

/**
 * Page À propos - Présentation de Wote
 */
function About() {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container">
          <div
            className="about-header"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/why.png)`,
            }}
          >
            <h1 className="about-title">À propos de <span className="about-title-accent">Wote</span></h1>
            <p className="about-tagline">{company.tagline}</p>
          </div>
        </div>
      </div>

      <div className="container">
        <section className="about-content">
          <div className="about-section">
            <h2 className="section-title">Qui est WOTE ?</h2>
            <p className="section-text">{presentation.intro}</p>
            <p className="section-text">{presentation.complement}</p>
          </div>

          <div className="about-section">
            <h2 className="section-title">{mission.title}</h2>
            <p className="section-text">{mission.text}</p>
            <p className="section-text">{mission.complement}</p>
          </div>

          <div className="about-section">
            <h2 className="section-title">{vision.title}</h2>
            {vision.paragraphs.map((paragraph, index) => (
              <p key={index} className="section-text">
                {paragraph}
              </p>
            ))}
          </div>

          <div className="about-section">
            <h2 className="section-title">Nos Valeurs</h2>
            <div className="values-grid">
              {values.map((value) => (
                <div key={value.id} className="value-card">
                  <h3 className="value-title">{value.title}</h3>
                  <p className="value-description">{value.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="about-section">
            <h2 className="section-title">Pourquoi WOTE ?</h2>
            <ul className="why-list">
              {whyWote.map((item) => (
                <li key={item.title} className="why-item">
                  <span className="why-icon">✓</span>
                  <div>
                    <strong>{item.title}</strong> — {item.text}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="about-cta">
          <h2 className="cta-title">Prêt à travailler avec nous ?</h2>
          <p className="cta-description">
            Contactez-nous pour discuter de votre projet
          </p>
          <WhatsAppButton />
        </section>
      </div>
    </div>
  );
}

export default About;
